/* eslint-disable @typescript-eslint/no-unused-vars */
import axios, { AxiosError } from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { Api } from '../../api/axios-config';
import { comOffline, somenteOnline } from '../../../offline/servico';
import { conexao } from '../../../offline/conexao';
import { sincronizar } from '../../../offline/sincronizacao';
import {
  guardarEmpresaImpressao, impressaoVendaOffline, salvarVendaOffline, vendaDependeDaFila,
} from '../../../offline/vendaOffline';

export interface IListagemMovimento {
  idmov: string;
  emissao: string;
  cpf: string;
  nome: string;
  numero: string;
  total: number;
}
export interface IitensMovimentoDialog {
  iditens: string;
  idprodutos: string;
  idref: string;
  qtds: number;
  qtde: number;
  un: string;
  preco: number;
  localizado?: string;
  original?: boolean;
  ean?: string;
  subtotal: number;
  total: number;
  filtro: string;
  referencia?: string;
  marca?: string;
  status?: number;
  descricao: string;
}
interface IgetMovimento {
  idmov: string;
  idparceiro: string;
  idplanoconta: string;
  numero: string;
  faturado: boolean;
  idoperacao: string;
  emissao: string;
  caixa: string;
  recebidas: string;
  nome: string;
  total: number;
  desconto: number;
  vprod: number;
  acrescimo: number;
  itens: IitensMovimentoDialog[];
}
export interface IempresaImpressao {
  idempresa: string;
  nome: string;
  cnpj: string;
  fantasia: string;
  logo: string;
  endereco: string;
  numero: string;
  bairro: string;
  uf: string;
  telefone: string;
  cidade: string;
}
interface IgetImpressao {
  idmov: string;
  dataoperacao: string;
  numero: string;
  total: number;
  vprod: number;
  desconto: number;
  acrescimo: number;
  cidade?: string;
  vendedor?: string;
  celular?: string;
  telefone?: string;
  cep?: string;
  nome?: string;
  endereco?: string;
  logo?: string;
  empresa: IempresaImpressao[];
  itens: IitensMovimentoDialog[];
}
interface IDetalheMovimento {
  idparceiro: string;
  idplanoconta: string;
  idoperacao: string;
  numero: string;
  emissao: string;
  total: number;
  desconto: number;
  vprod: number;
  acrescimo: number;
  obs?: string;
}
interface IDetalheMovimentoPdv {
  idparceiro: string;
  idmov: string;
  idplanoconta: string;
  idoperacao: string;
  numero: string;
  emissao: string;
  total: number;
  desconto: number;
  vprod: number;
  acrescimo: number;
  obs?: string;
  formasPagamento?: { idoperacao: string; valor: number; categoria?: string; idcontadestino?: string }[];
}
interface IDetalheMovimentoupdate {
  idparceiro: string;
  idplanoconta: string;
  idoperacoes: string;
  emissao: Date;
  numero: string;
  total: number;
  desconto: number;
  vprod: number;
  acrescimo: number;
}

interface IItensids {
  iditens: string;
}

interface IParcelasFaturamento {
  idrec: string;
  idplanoconta: string;
  emissao: string;
  vencimento: string;
  pagamento: string;
  tipo: number;
  parcela: string;
  vreceber: number;
  historico: string;
  juros: number;
  desconto: number;
  acrescimo: number;
  vrecebido: number;
  vparcela: number;
  venda: number;
  qtdparcelas: number;
}

type TotalCount = {
  data: IListagemMovimento[];
  totalCount: number;
}

interface ErrorResponse {
  // Erro de negócio/banco (ex.: Createpdv.ts) vem como { errors: { default:
  // 'mensagem' } }; erro de validação do yup (CreatepdvValidation) vem como
  // { errors: { idparceiro: 'msg', '[0].un': 'msg', ... } } — uma entrada
  // por campo inválido, sem chave 'default'. Os dois formatos passam por
  // esse mesmo tipo — ver extrairMensagemErro abaixo, que trata ambos.
  errors: Record<string, string>;
}

// Sem tratar os dois formatos de erro do backend (ver comentário de
// ErrorResponse acima), um erro de validação (ex.: item sem UN, cliente não
// selecionado numa venda a prazo) sempre caía no fallback genérico "Erro
// desconhecido" — a mensagem de verdade (que campo, por quê) ficava presa
// num objeto sem chave 'default', e o operador nunca via o motivo real.
const extrairMensagemErro = (errors: unknown): string => {
  if (!errors || typeof errors !== 'object') return 'Erro desconhecido';
  const mapa = errors as Record<string, string>;
  if (mapa.default) return mapa.default;
  const mensagens = Object.values(mapa).filter((valor): valor is string => typeof valor === 'string' && valor.length > 0);
  return mensagens.length > 0 ? mensagens.join(' | ') : 'Erro desconhecido';
};


const getAll = async (page = 1, dataInicial = '', dataFinal = '', filter = '', tipo = ''): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/vendas?page=${page}&limit=${8}&tipo=${tipo}&filter=${filter}&datainicial=${dataInicial}&datafinal=${dataFinal}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || 17),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getById = async (id: string): Promise<IgetMovimento | Error> => {
  try {
    const { data } = await Api.get(`/vendas/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const create = async (dados: IDetalheMovimento, dadositens: IitensMovimentoDialog[], faturamento: IParcelasFaturamento[]): Promise<string | Error> => {
  try {
    const guuid = uuidv4();
    const dadosExtraidos = dadositens.map(({ descricao,  marca, referencia, idref, filtro, ...restoDoObjeto }) => ({
      idmov: guuid,
      tipo: 2, ...restoDoObjeto
    }));
    const Pfaturamento = faturamento.map(({ qtdparcelas, ...restoDoObjeto }) => ({ idmov: guuid, ...restoDoObjeto }));
    const {numero, ...dadosIDetalheEntrada } = dados;
    const dadosEntrada = { idmov: guuid, tipo: 2, ...dadosIDetalheEntrada };
    const { data } = await Api.post<IDetalheMovimento>('/vendas', [dadosEntrada, dadosExtraidos, Pfaturamento]);
    if (Object.keys(data).length === 0) {
      return guuid;
    }

    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const createpdvOnline = async (idmov: string, corpo: unknown[]): Promise<string | Error> => {
  try {
    const { data } = await Api.post<IDetalheMovimento>('/vendaspdv', corpo);
    if (Object.keys(data).length === 0) {
      return idmov;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        return new Error(extrairMensagemErro(axiosError.response.data?.errors));
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
// Sem internet (ou se a venda depende de algo ainda na fila — caixa aberto
// offline, parceiro novo offline), a venda é gravada localmente e enviada
// na próxima sincronização com o mesmo idmov (ver shared/offline). Pra
// quem chama, o resultado é o mesmo de uma venda online: o idmov.
const createpdv = async (dados: IDetalheMovimentoPdv, dadositens: IitensMovimentoDialog[], faturamento: IParcelasFaturamento[]): Promise<string | Error> => {
  const dadosExtraidos = dadositens.map(({ descricao,  marca, referencia, idref, filtro, ...restoDoObjeto }) => ({
    idmov: dados.idmov,
    tipo: 2, ...restoDoObjeto
  }));
  const Pfaturamento = faturamento.map(({ qtdparcelas, ...restoDoObjeto }) => ({ idmov: dados.idmov, ...restoDoObjeto }));
  const {numero, ...dadosIDetalheEntrada } = dados;
  const dadosEntrada = {tipo: 2, ...dadosIDetalheEntrada };
  const corpo = [dadosEntrada, dadosExtraidos, Pfaturamento];
  const idconta = String(Api.defaults.headers.idconta || '');
  const gravarOffline = () => salvarVendaOffline(idconta, corpo, dados, dadositens);

  if (conexao.estaOffline()) return gravarOffline();
  if (await vendaDependeDaFila(dados.idparceiro)) {
    const idmov = await gravarOffline();
    sincronizar();
    return idmov;
  }
  const resultado = await createpdvOnline(dados.idmov, corpo);
  if (resultado instanceof Error && conexao.estaOffline()) return gravarOffline();
  return resultado;
};
const imprimirNota = async (id: string): Promise<Blob | Error> => {
  try {
    const response = await Api.get(`/geradanfnfce/${id}`, {
      responseType: 'blob', 
    });
    if (response.data) {
      return response.data;
    }
    return new Error('Erro ao gerar a nota.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const updateById = async (id: string, dados: IDetalheMovimento, dadositens: IitensMovimentoDialog[], iddeletados: IItensids[], faturamento: IParcelasFaturamento[]): Promise<void | Error> => {
  try {
    const dadosExtraidos = dadositens.map(({ descricao,  marca, referencia, ...restoDoObjeto }) => ({ idmov: id, tipo: 1,  ...restoDoObjeto }));
    const {...dadosIDetalheEntrada} = dados;
    const dadosEntrada = {idmov: id, ...dadosIDetalheEntrada };
    const Pfaturamento = faturamento.map(({ qtdparcelas, ...restoDoObjeto }) => ({ idmov: id, ...restoDoObjeto }));
    await Api.put(`/vendas/${id}`, [dadosEntrada, dadosExtraidos, iddeletados, Pfaturamento]);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/vendas/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const ImpressaoOnline = async (id: string): Promise<IgetImpressao | Error> => {
  try {
    const { data } = await Api.get(`/vendasimpressao/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
// Venda ainda na fila offline: cupom montado localmente (o servidor ainda
// não conhece essa venda). As demais: servidor, guardando os dados da
// empresa pra poder imprimir cupom offline depois.
const Impressao = async (id: string): Promise<IgetImpressao | Error> => {
  const local = await impressaoVendaOffline(id);
  if (local) return local;
  return comOffline(
    () => ImpressaoOnline(id),
    async () => new Error('Impressão desta venda indisponível sem internet.'),
    (resultado) => guardarEmpresaImpressao(resultado.empresa),
  );
};

// ---------- Notas fiscais das vendas do PDV (ver DialogNotasFiscaisPDV) ----------

export type TSituacaoNfcePdv = 'pendentes' | 'emitidas';

export interface IVendaPdvNfce {
  idmov: string;
  numero: string;
  emissao: string;
  total: number;
  nomeParceiro: string;
  operacao: string;
  // NFC-e da venda: statusnfce 1 = tentativa não autorizada, 2 = autorizada.
  idnfce: string | null;
  nfe: number | null;
  serie: number | null;
  statusnfce: number | null;
  pagamentos: { categoria: string; valor: number }[];
}

const listarNfceOnline = async (
  situacao: TSituacaoNfcePdv, page = 1, filter = '', excluiroperacao = '', limit = 20,
): Promise<{ data: IVendaPdvNfce[]; totalCount: number } | Error> => {
  try {
    // silencioso: se o servidor ainda não tiver esta rota (404), só mostra o
    // erro — o interceptor do PDV não desloga (ver ErrorInterceptor).
    const silencioso: Record<string, unknown> = { silencioso: true };
    const { data, headers } = await Api.get('/vendaspdvnfce', {
      params: { situacao, page, limit, filter, excluiroperacao },
      ...silencioso,
    });
    return { data, totalCount: Number(headers['x-total-count'] || 0) };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) return new Error(extrairMensagemErro(axiosError.response.data?.errors));
      if (axiosError.request) return new Error('Nenhuma resposta do servidor');
      return new Error(axiosError.message);
    }
    return new Error('Erro inesperado');
  }
};

// Vendas do PDV sem NFC-e autorizada ('pendentes', pra emitir depois) ou com
// NFC-e autorizada ('emitidas', pra reimprimir) — só da sessão de caixa
// ativa do usuário (o servidor resolve qual). Só com internet; as vendas
// offline da sessão vêm à parte (listarVendasPdvOffline).
const listarNfce = (...args: Parameters<typeof listarNfceOnline>) => somenteOnline(() => listarNfceOnline(...args));

export interface ITotaisNfceSessao {
  emitidas: { quantidade: number; total: number };
  pendentes: { quantidade: number; total: number };
}

const totaisNfceOnline = async (excluiroperacao = ''): Promise<ITotaisNfceSessao | Error> => {
  try {
    const silencioso: Record<string, unknown> = { silencioso: true };
    const { data } = await Api.get('/vendaspdvnfcetotais', { params: { excluiroperacao }, ...silencioso });
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) return new Error(extrairMensagemErro(axiosError.response.data?.errors));
      if (axiosError.request) return new Error('Nenhuma resposta do servidor');
      return new Error(axiosError.message);
    }
    return new Error('Erro inesperado');
  }
};

// Totais de NFC-e (emitidas / sem nota) da sessão de caixa ativa — sempre
// da sessão inteira, não da página exibida. Só com internet.
const totaisNfce = (excluiroperacao = '') => somenteOnline(() => totaisNfceOnline(excluiroperacao));

// PDF (DANFE) de uma NFC-e já autorizada — recebe o idnfce, não o idmov.
const reimprimirNfce = (idnfce: string) => somenteOnline(() => imprimirNota(idnfce));

export const VendasService = {
  listarNfce,
  totaisNfce,
  reimprimirNfce,
  getAll,
  createpdv,
  create,
  getById,
  imprimirNota,
  updateById,
  Impressao,
  deleteById,
};